import { authFetch } from '../AuthFetch';
import { createAction } from 'redux-actions';

import { forwardToFindPostPhotos } from './maintenanceAuditAction.js'

export const forwardToSelectCategory = createAction('SELECT_CATEGORY');
export const forwardToSetNote = createAction('SET_NOTE');
export const forwardChangeIsLoadingPage = createAction('LOADING_PAGE');
export const forwardChangeCheckCardLabelId = createAction('CHANGE_CHECK_CARD_LABEL_ID');
export const forwardShowInputLabelId = createAction('SHOW_INPUT_LABEL_ID');

export const forwardToAddMaintenanceDetail = (cardPk, epc, categoryPk, setPk, itemPk, note, operator) => (
  (dispatch) => {
    let maintenanceDetail = {
      maintenanceCardId: cardPk,
      categoryId: categoryPk,
      epc: epc,
      setId: setPk,
      itemId: itemPk,
      note: note,
      refineStatus: "PASS",
      status: "CREATED",
      creator: operator,
    };
    let url = '/maintenance/details';
    authFetch('POST', url, JSON.stringify(maintenanceDetail), (json) => {
      dispatch({
        type: 'APPEND_CHECK_DETAIL',
        payload: json
      });
    });
  }
);

export const forwardToReloadCheckCard = (id) => (
  (dispatch) => {
    let url = '/maintenance/cards/' + id;
    authFetch('GET', url, null, (json) => {
      dispatch({
        type: 'RELOAD_MAINTENANCE_CARD',
        payload: json
      });
    });
  }
);

export const forwardToFindCategories = () => (
  (dispatch) => {
    let url = '/maintenance/check/categories';
    authFetch('GET', url, null, (json) => {
      dispatch({
        type: 'FIND_CATEGORIES',
        payload: json
      });
    });
  }
);

export const forwardToCleanAlert = () => (
  (dispatch) => {
    dispatch({
      type: 'CLEAN_ALERT',
      payload: null
    });
  }
);

export const forwardToFindMaintenanceDetails = (cardId) => (
  (dispatch) => {
    let url = '/maintenance/cards/' + cardId + '/details';
    authFetch('GET', url, null, (json) => {
      dispatch({
        type: 'FIND_MAINTENANCE_DETAILS',
        payload: json
      });
    });

  }
);

// 標記未送修
export const forwardToMarkAsNotDilivered = (cardId, cardCode, category, operator) => (
  (dispatch) => {
    let request = {
      cardId: cardId,
      code: cardCode,
      type: category,
      operator: operator,
    };
    let url = '/maintenance/cards/c' + cardCode + '/dilivered';
    authFetch('POST', url, JSON.stringify(request), (json) => {
      dispatch({
        type: 'COMPLETE_CLOTH_PANT_NOT_DILIVERED',
        payload: json
      });
    });
  }
);

// 取消標記未送修
export const forwardToCancelNotDilivered = (cardId, cardCode, category, operator) => (
  (dispatch) => {
    let request = {
      cardId: cardId,
      code: cardCode,
      type: category,
      operator: operator,
    };
    let url = '/maintenance/cards/c' + cardCode + '/cancelDilivered';
    authFetch('POST', url, JSON.stringify(request), (json) => {
      dispatch({
        type: 'COMPLETE_CLOTH_PANT_NOT_DILIVERED',
        payload: json
      });
    });
  }
);

// 建議不再使用
export const forwardToMarkCardAsDiscard = (cardId, cardCode, category, operator) => (
  (dispatch) => {
    let request = {
      cardId: cardId,
      code: cardCode,
      type: category,
      operator: operator,
    };
    let url = '/maintenance/cards/c' + cardCode + '/discard';
    authFetch('POST', url, JSON.stringify(request), (json) => {
      dispatch({
        type: 'COMPLETE_CLOTH_PANT_DISCARD',
        payload: json
      });
    });
  }
);

export const forwardToCompleteClothChecking = (cardId, cardCode, operator) => (
  (dispatch) => {
    let request = {
      cardId: cardId,
      code: cardCode,
      type: 'CLOTH',
      operator: operator
    };
    let url = '/maintenance/cards/c' + cardCode + '/status';
    authFetch('POST', url, JSON.stringify(request), (json) => {
      dispatch({
        type: 'COMPLETE_CLOTH_PANT_CHECKING',
        payload: json
      });
    });
  }
);

export const forwardToCompletePantChecking = (cardId, cardCode, operator) => (
  (dispatch) => {
    let request = {
      cardId: cardId,
      code: cardCode,
      type: 'PANT',
      operator: operator
    };
    let url = '/maintenance/cards/c' + cardCode + '/status';
    authFetch('POST', url, JSON.stringify(request), (json) => {
      dispatch({
        type: 'COMPLETE_CLOTH_PANT_CHECKING',
        payload: json
      });
    });
  }
);

export const forwardToRestoreClothChecking = (cardId, cardCode, operator) => (
  (dispatch) => {
    let request = {
      cardId: cardId,
      code: cardCode,
      type: 'CLOTH',
      operator: operator
    };
    let url = '/maintenance/cards/c' + cardCode + '/restore';
    authFetch('POST', url, JSON.stringify(request), (json) => {
      dispatch({
        type: 'COMPLETE_CLOTH_PANT_CHECKING',
        payload: json
      });
    });
  }
);

export const forwardToRestorePantChecking = (cardId, cardCode, operator) => (
  (dispatch) => {
    let request = {
      cardId: cardId,
      code: cardCode,
      type: 'PANT',
      operator: operator
    };
    let url = '/maintenance/cards/c' + cardCode + '/restore';
    authFetch('POST', url, JSON.stringify(request), (json) => {
      dispatch({
        type: 'COMPLETE_CLOTH_PANT_CHECKING',
        payload: json
      });
    });
  }
);

export const forwardToShowDelCheckItemModal = () => (
  (dispatch) => {
    dispatch(
      {
        type: 'SHOW_DEL_CHECK_ITEM_MODAL',
        payload: null,
      }
    )
  }
);

export const forwardToShowRfidConfig = () => (
  (dispatch) => {
    let url = '/maintenance/readers';
    authFetch('POST', url, JSON.stringify({}), (json) => {
      dispatch({
        type: 'SHOW_RFID_CONFIG',
        payload: json
      });
    });
  }
);

export const forwardToAssignEpcTag = (catCode, card, epc, operator) => {
  let typeString = '';
  if (catCode === 0) {
    typeString = "CLOTH";
  } else if (catCode === 1) {
    typeString = "PANT";
  }

  let cardrquest = {
    cardId: card.id,
    type: typeString,
    operator: operator,
    epc: epc
  };
  return (dispatch) => {

    let url = '/maintenance/chips/rpc/assign/c' + card.id + '/t' + typeString;
    authFetch('POST', url, JSON.stringify(cardrquest), (json) => {
      dispatch({
        type: 'SET_CHIP_EPC_2',
        payload: json
      });
    });
  }
}

export const forwardToAssignEpcTagByLabelId = (catCode, card, labelId, operator) => {
  let typeString = '';
  if (catCode === 0) {
    typeString = "CLOTH";
  } else if (catCode === 1) {
    typeString = "PANT";
  }

  let cardrquest = {
    cardId: card.id,
    type: typeString,
    operator: operator,
    labelId: labelId
  };
  return (dispatch) => {

    let url = '/maintenance/chips/rpc/assign/c' + card.id + '/t' + typeString;
    authFetch('POST', url, JSON.stringify(cardrquest), (json) => {
      dispatch({
        type: 'SET_CHIP_EPC_2',
        payload: json
      });
    });
  }
}

export const forwardToMarkAsNotKKProduct = (catCode, card, operator) => (

  (dispatch) => {
    let typeString;
    if (catCode === 0) {
      typeString = "CLOTH";
    } else if (catCode === 1) {
      typeString = "PANT";
    }

    let cardrquest = {
      cardId: card.id,
      type: typeString,
      operator: operator,
    };
    let url = '/maintenance/chips/rpc/mark/c' + card.id + '/t' + typeString;
    authFetch('POST', url, JSON.stringify(cardrquest), (json) => {
      dispatch({
        type: 'SET_CHIP_EPC',
        payload: json
      });
    });
  }
);

export const forwardToMarkAsNoEpc = (catCode, card, operator) => (

  (dispatch) => {
    let typeString;
    if (catCode === 0) {
      typeString = "CLOTH";
    } else if (catCode === 1) {
      typeString = "PANT";
    }

    let cardrquest = {
      cardId: card.id,
      type: typeString,
      operator: operator,
    };
    let url = '/maintenance/chips/epc/mark/c' + card.id + '/t' + typeString;
    authFetch('POST', url, JSON.stringify(cardrquest), (json) => {
      dispatch({
        type: 'SET_CHIP_EPC',
        payload: json
      });
    });
  }
);

export const forwardToReloadCurrentEpc = (card, catNo) => (
  (dispatch) => {
    let epc;
    let alreadyDiscard;
    if (catNo === 0) {
      epc = card.clothEpc;
      alreadyDiscard = card.alreadyDiscardClothes;
    } else if (catNo === 1) {
      epc = card.pantEpc;
      alreadyDiscard = card.alreadyDiscardPant;
    }

    dispatch({
      type: 'SET_CHIP_EPC_2',
      payload: { data: { epc: epc, alreadyDiscard, alreadyDiscard } }
    });
  }
);

export const forwardToAssignReaderPort = (port) => (
  (dispatch) => {
    dispatch({
      type: 'ASSIGN_READER_PORT',
      payload: port
    });
  }
);

export const forwardToAssignReaderName = (name) => (
  (dispatch) => {
    dispatch({
      type: 'ASSIGN_READER_NAME',
      payload: name
    });
  }
);

export const forwardToAssignReaderHostName = (hostname) => (
  (dispatch) => {
    dispatch({
      type: 'ASSIGN_READER_HOSTNAME',
      payload: hostname
    });
  }
);

export const forwardToAssignReaderSensitivity = (sensitivity) => (
  (dispatch) => {
    dispatch({
      type: 'ASSIGN_READER_SENSITIVITY',
      payload: sensitivity
    });
  }
);

export const forwardToReadRfidChips = (speedway) => (
  (dispatch) => {

    dispatch({
      type: 'LOADING_CHIP_EPCS'
    });

    let url = '/maintenance/chips';
    authFetch('POST', url, JSON.stringify(speedway), (json) => {
      dispatch({
        type: 'SHOW_CHIP_EPCS',
        payload: json
      });
    });
  }
);

export const forwardToCleanRfidChips = () => (
  (dispatch) => {
    dispatch(
      {
        type: 'CLEAN_CHIP_EPCS',
        payload: null,
      }
    )
  }
);

export const forwardToAssignRfidReader = (speedway) => (
  (dispatch) => {
    dispatch(
      {
        type: 'ASSIGN_SPEEDWAY',
        payload: speedway,
      }
    )
  }
);

export const forwardToHideRfidConfig = () => (
  (dispatch) => {
    dispatch(
      {
        type: 'HIDE_RFID_CONFIG',
        payload: null,
      }
    )
  }
);

export const forwardToShowPhotoBlk = () => (
  (dispatch) => {
    dispatch(
      {
        type: 'SHOW_PHOTO_BLK',
        payload: null,
      }
    )
  }
);

export const forwardToHideDelCheckItemModal = () => (
  (dispatch) => {
    dispatch(
      {
        type: 'HIDE_DEL_CHECK_ITEM_MODAL',
        payload: null,
      }
    )
  }
);

export const forwardToHidePhotoBlk = () => (
  (dispatch) => {
    dispatch(
      {
        type: 'HIDE_PHOTO_BLK',
        payload: null,
      }
    )
  }
);

export const forwardToSetRemoveItemType = (itemType) => (
  (dispatch) => {
    dispatch(
      {
        type: 'SET_REMOVE_CHECK_ITEM_TYPE',
        payload: itemType,
      }
    )
  }
);

export const forwardToCreateReader = (reader) => (
  (dispatch) => {
    let url = '/maintenance/readers/create';
    authFetch('POST', url, JSON.stringify(reader), (json) => {
      dispatch({
        type: 'VALIDATE_CREATE_RFID_READER',
        payload: json
      });
      dispatch(forwardToShowRfidConfig());
      
      // 新增成功才assign資料到頁面
      if (json.statusCode === '0') {
        dispatch(forwardToAssignRfidReader(reader));
      }
    });
  }
);

export const forwardToRemoveMaintenanceDetail = (detailPk, cardPk) => (
  (dispatch) => {
    let request = { id: detailPk, maintenanceCardId: cardPk };
    let url = '/maintenance/details/' + detailPk + '/del';
    authFetch('POST', url, JSON.stringify(request), (json) => {
      dispatch({
        type: 'FIND_MAINTENANCE_DETAILS',
        payload: json
      });
    });
  }
);

export const forwardToUploadPhoto = (dataUri, card, type, stage, operator, ignoreCardChecking) => (
  (dispatch) => {
    let url = "/maintenance/photos/cards/i" + card.id + "/type/" + type + "/take";
    let request = {
      cardId: card.id,
      type: type,
      image: dataUri,
      stage: stage,
      operator: operator,
      ignoreCardChecking: ignoreCardChecking
    };

    authFetch('POST', url, JSON.stringify(request), (json) => {
      dispatch({
        type: 'QUEUE_PHOTO',
        payload: json,
      });
    });
  }
);

export const forwardToFindPhotos = (card, type, stage) => (
  (dispatch) => {
    let url = "/maintenance/photos/cards/i" + card.id + "/type/" + type + "/find";
    let request = {
      cardId: card.id,
      type: type,
      stage: stage,
    };
    authFetch('POST', url, JSON.stringify(request), (json) => {
      dispatch({
        type: 'QUEUE_PHOTO',
        payload: json,
      });
    });
  }
);

export const forwardToMarkPop = () => (
  (dispatch) => {
    dispatch({
      type: 'MARK_POP_PHOTO',
      payload: null,
    });
  }
);
export const forwardToMarkQueue = () => (
  (dispatch) => {
    dispatch({
      type: 'MARK_QUEUE_PHOTO',
      payload: null,
    });
  }
);

export const forwardToDeletePhotoById = (photoId, card, type, stage) => (
  (dispatch) => {
    let url = '/maintenance/photos/' + photoId;
    authFetch('DELETE', url, null, (json) => {
      dispatch({
        type: '',
        payload: json
      });
      if (stage === "PRE") {
        dispatch(forwardToFindPhotos(card, type, stage));
      } else if (stage === "POST") {
        dispatch(forwardToFindPostPhotos(card, type, stage));
      }
    });
  }
);

export const forwardToDeleteReaderByName = (speedwayName) => (
  (dispatch) => {
    let url = '/maintenance/readers/' + speedwayName;
    authFetch('DELETE', url, null, (json) => {
      dispatch({
        type: '',
        payload: json
      });
      dispatch(forwardToShowRfidConfig());
    });
  }
);

export const resetCardCategory = createAction('RESET_CARD_CATEGORY');
export const cleanCheckCardAlert = createAction('CLEAN_CHECK_CARD_ALERT');
export const changeCheckCardPreviousPage = createAction('CHANGE_CHECK_CARD_PREVIOUS_PAGE');


// WEBPACK FOOTER //
// ./src/actions/checkCardActions.js